<!--
 * @Author: ZhaoG
 * @Date: 2025-04-10 18:34:16
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-20 09:08:44
 * @FilePath: \sra-fe\src\views\register\regView\supRegDetail.vue
 * @Description:
-->
<template>
  <div
    :class="
      auditStatus + '' !== '' && auditStatus + '' !== '0'
        ? 'merchants-shop template-body template-detail-body'
        : ''
    "
    :style="
      auditStatus + '' !== '' && auditStatus + '' !== '0'
        ? 'padding-bottom:60px'
        : ''
    "
  >
    <el-top-nav-menu-4
      :companyTitle="$t('basicLayout.title')"
      :dashboard="shopPage"
      :logoIsShow="false"
      :showInput="false"
      :Menu4Href="Menu4Href"
      ref="topNavMenu"
      :logo="LOGO"
      width="1180px"
      padding="0"
      :showHelp="showHelp"
    >
      <!-- <div class="ldg" @click="goser">
        <span class="dpng">{{ $t("page.applyUsername.btn.msg10") }}</span>-->
        <!-- 我已注册，查看审批进展 -->
        <!--<div class="los">
          <img :src="leftgg" />
        </div>
      </div> -->
    </el-top-nav-menu-4>
    <!--主体部分-->
    <div
      class="detail-box ccui-clearfix"
      :style="
        auditStatus + '' !== '' && auditStatus + '' !== '0'
          ? 'max-width: 1180px;margin: 20px auto'
          : 'max-width: 1180px;margin: 5px auto'
      "
    >
      <!--  主体左侧内容  -->
      <div class="detail-info">
        <!--  审批状态 icon  -->
        <div class="detail-info-el-Label" style="top: 40px">
          <el-label
            :type="approving"
            v-if="approvingStatus"
            :key="approving"
          ></el-label>
        </div>
        <div class="ccui-app-container-detail">
          <div class="ccui-app-container-detail-body">
            <el-tabs
              v-model="activeName"
              class="el-tabs__customize dic-sub-tabs-style01"
            >
              <el-tab-pane label="申请用户名" name="tab01">
                <!-- 申请用户名 -->
                <basicInfo
                  title="登录账号和密码"
                  labelWidth="180px"
                  :field-list="supplierAccountInfoBO1"
                  :data-info="accountInfo"
                ></basicInfo>
                <basicInfo
                  title="联系人和联系方式"
                  labelWidth="180px"
                  :field-list="detailBaseInfo.supplierAccountInfoBO2"
                  :data-info="accountInfo"
                >
                  <template #certType="{ slotData }">
                    <div>{{ getCertTypeTranslate(slotData) }}</div>
                  </template>
                  <template #imageCheck="{ slotData }">
                    <el-button
                      style="padding: 6px;"
                      :disabled="!getCheckImageUrl(slotData)"
                      type="text"
                      @click="handlerPreview(slotData)"
                      >点击预览
                    </el-button>
                  </template>
                  <template #isOverseaMobile="{ slotData }">
                    <div>{{ getIsOverseaMobileTranslate(slotData) }}</div>
                  </template>
                </basicInfo>
                <basicInfo
                  title="推荐单位"
                  labelWidth="180px"
                  :field-list="detailBaseInfo.supplierAccountInfoBO3"
                  :data-info="accountInfo"
                ></basicInfo>
              </el-tab-pane>

              <el-tab-pane
                label="供应商基本信息"
                name="tab02"
                v-if="
                  basicInfoData.supMatType !== '' &&
                    basicInfoData.supType !== ''
                "
              >
                <!-- 供应商基本信息 -->
                <basicInfo
                  title="基本信息"
                  labelWidth="180px"
                  :field-list="supplierBaseInfo1"
                  :data-info="basicInfoData"
                ></basicInfo>
                <basicInfo
                  title="生产商"
                  labelWidth="180px"
                  :field-list="detailBaseInfo.supplierBaseInfo2"
                  :data-info="basicInfoData"
                ></basicInfo>
                <basicInfo
                  title="经销商"
                  labelWidth="180px"
                  :field-list="detailBaseInfo.supplierBaseInfo3"
                  :data-info="basicInfoData"
                ></basicInfo>
              </el-tab-pane>

              <el-tab-pane
                label="联系信息"
                name="tab03"
                v-if="supplierContactData.legalContactMobile !== ''"
              >
                <!-- 联系信息 -->
                <basicInfo
                  title="联系信息"
                  label-width="192px"
                  :field-list="detailBaseInfo.supplierContact"
                  :data-info="supplierContactData"
                >
                  <template #certType="{ slotData }">
                    <div>{{ getCertTypeTranslate(slotData) }}</div>
                  </template>
                  <template #imageCheck="{ slotData }">
                    <el-button
                      style="padding: 6px;"
                      :disabled="!getCheckImageUrl(slotData)"
                      type="text"
                      @click="handlerPreview(slotData)"
                      >点击预览
                    </el-button>
                  </template>
                  <template #isOverseaMobile="{ slotData }">
                    <div>{{ getIsOverseaMobileTranslate(slotData) }}</div>
                  </template>
                </basicInfo>
                <el-group-title title="主体信息" style="margin-top: 30px;">
                  <template slot="groupTitle">
                    <el-table
                      :data="mainstayTableData"
                      :fit="true"
                      class="dic-sub-table-style01"
                      border
                      show-overflow
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        label="实控类型"
                        prop="mainstayTypename"
                        width="120"
                        show-overflow-tooltip
                      >
                      </el-table-column>
                      <el-table-column
                        label="实控主体"
                        prop="mainstayName"
                        width="130"
                        show-overflow-tooltip
                      >
                      </el-table-column>
                      <el-table-column
                        label="控制主体代码或证件号"
                        prop="mainstayIdcard"
                        width="200"
                        show-overflow-tooltip
                      >
                      </el-table-column>
                    </el-table>
                  </template>
                </el-group-title>
                <el-group-title title="董监高" style="margin-top: 30px;">
                  <template slot="groupTitle">
                    <el-table
                      :data="djgTableData"
                      :fit="true"
                      class="dic-sub-table-style01"
                      border
                      show-overflow
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        label="董监高类型"
                        prop="djgTypename"
                        width="120"
                        show-overflow-tooltip
                      >
                      </el-table-column>
                      <el-table-column
                        label="董监高人员姓名"
                        prop="djgName"
                        width="130"
                        show-overflow-tooltip
                      >
                      </el-table-column>
                      <!-- <el-table-column
                        label="董监高证件类型"
                        prop="certType"
                        width="130"
                        show-overflow-tooltip
                      >
                        <template #default="{ row }">
                          <div>{{ getCertTypeTranslate(row.certType) }}</div>
                        </template>
                      </el-table-column> -->
                      <el-table-column
                        label="董监高人员证件号"
                        prop="djgIdcard"
                        width="200"
                        show-overflow-tooltip
                      >
                      </el-table-column>
                      <!-- <el-table-column
                        label="身份证国徽面"
                        prop="positiveImageUrl"
                        width="100"
                        show-overflow-tooltip
                      >
                        <template #default="{ row }">
                          <el-button
                            style="padding: 6px;"
                            :disabled="
                              row.certType !== 1 ||
                                !getCheckImageUrl(row.positiveImageUrl)
                            "
                            type="text"
                            @click="handlerPreview(row.positiveImageUrl)"
                            >点击预览
                          </el-button>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="身份证人像面"
                        prop="negativeImageUrl"
                        width="100"
                        show-overflow-tooltip
                      >
                        <template #default="{ row }">
                          <el-button
                            style="padding: 6px;"
                            :disabled="
                              row.certType !== 1 ||
                                !getCheckImageUrl(row.negativeImageUrl)
                            "
                            type="text"
                            @click="handlerPreview(row.negativeImageUrl)"
                            >点击预览
                          </el-button>
                        </template>
                      </el-table-column> -->
                    </el-table>
                  </template>
                </el-group-title>
                <!--                  <supplierTable-->
                <!--                    title="常用联系人信息"-->
                <!--                    :table-head="detailBaseInfo.supplierCommonLinkInfo"-->
                <!--                    :table-data="commonLinkInfoData"-->
                <!--                  ></supplierTable>-->
              </el-tab-pane>

              <el-tab-pane
                label="产品信息"
                name="tab04"
                v-if="productInfoData.length !== 0"
              >
                <!-- 产品信息 -->
                <supplierTable
                  :table-head="detailBaseInfo.productInfo"
                  :table-data="productInfoData"
                  :show-index="true"
                ></supplierTable>
              </el-tab-pane>

              <el-tab-pane
                label="财务信息"
                name="tab05"
                v-if="
                  financeInfoData.bankId !== '' &&
                    financeInfoData.bankName !== ''
                "
              >
                <!-- 财务信息  -->
                <basicInfo
                  title="财务信息"
                  label-width="180px"
                  :field-list="detailBaseInfo.financeInfo"
                  :data-info="financeInfoData"
                ></basicInfo>
              </el-tab-pane>

              <el-tab-pane
                label="历史合作业绩"
                name="tab06"
                v-if="cooperationPerformanceData.cooperEnterprise !== ''"
              >
                <!-- 历史合作业绩 -->
                <basic-info
                  title="历史合作业绩"
                  label-width="180px"
                  :field-list="detailBaseInfo.cooperationPerformance"
                  :data-info="cooperationPerformanceData"
                ></basic-info>
              </el-tab-pane>

              <el-tab-pane
                label="绿色低碳"
                name="tab11"
              >
              <greenLowCarbonPreview
                  :cooperationForm="cooperationForm"
                  :temGreenInfo="temGreenInfo"
                ></greenLowCarbonPreview>
              </el-tab-pane>

              <el-tab-pane
                label="资质文件"
                name="tab07"
                v-if="certificatesData.length !== 0"
              >
                <!-- 资质文件  -->
                <supplierTable
                  title="资质文件信息"
                  :table-head="detailBaseInfo.certificates"
                  :table-data="certificatesData"
                  downloadType="fileUrl"
                >
                </supplierTable>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <!--  右边审批状态  -->
      <approval-read-record
        v-if="auditStatus + '' !== '' && auditStatus + '' !== '0'"
        :approvalRecordData="activities"
      />
    </div>
    <!--底部功能按钮-->
    <el-bottom-guide v-if="auditStatus + '' !== '3'">
      <ul class="ccui-bottom-button">
        <li>
          <el-button
            v-if="
              auditStatus + '' === '0' ||
                auditStatus + '' === '' ||
                auditStatus + '' === '4'
            "
            type="bottom"
            size="small"
            icon="icon-ccui-edit"
            @click="handlePerfect"
            >完善信息</el-button
          >
          <!-- 完善信息 -->
        </li>
        <li>
          <el-button
            v-if="auditStatus + '' === '1'"
            type="bottom"
            size="small"
            icon="icon-ccui-reject"
            @click="handleRecall"
            >撤回申请</el-button
          >
          <!-- 撤回申请 -->
        </li>
        <li>
          <el-button
            v-if="auditStatus + '' === '2'"
            type="bottom"
            size="small"
            icon="icon-ccui-edit"
            @click="handlePerfect(1)"
            >修改信息</el-button
          >
          <!-- 修改信息 -->
        </li>
      </ul>
    </el-bottom-guide>
    <el-dialog :visible.sync="dialogVisible" title="预览" width="600px">
      <img style="width: 100%;height: 300px;" :src="imageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { addUrlPerFix } from "@/utils";
import detailBaseInfo from "@/setting/detail-base-info";
import basicInfo from "./components/basic-info";
import supplierTable from "./components/supplier-table";
import approvalReadRecord from "./components/approval-read-record";
import { bidSupplierMixin } from "@/views/mixins/mixin-bidSupplier";
import { dealSupApprReturn, qrySupAuditDetail } from "@/api/supRegister";
import greenLowCarbonPreview from "@/views/register/material/maPerfectInfo/greenLowCarbonPreview.vue"
export default {
  name: "supRegDetail",
  mixins: [bidSupplierMixin],
  components: {
    basicInfo,
    supplierTable,
    approvalReadRecord,
    greenLowCarbonPreview
  },
  data() {
    return {
      shopPage: addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      LOGO: require("@/assets/images/logoS.png"),
      leftgg: require("@/assets/images/llop.png"),
      Menu4Href: true,
      showHelp: false,
      isWhite: false,
      isHaiwaiorGAT: false,
      detailBaseInfo: detailBaseInfo,
      activeName: "tab01",
      routeData: this.$route.query,
      supplierAccountInfoBO1: this.unfreeze(
        detailBaseInfo.supplierAccountInfoBO1
      ),
      supplierBaseInfo1: this.unfreeze(detailBaseInfo.supplierBaseInfo1),
      approvalRecordDataNew: [],
      dialogVisible: false,
      imageUrl: null
    };
  },
  computed: {
    getCertTypeTranslate() {
      return val => {
        if (val === 1) {
          return "身份证";
        } else if (val === 2) {
          return "境外社保";
        } else {
          return "-";
        }
      };
    },
    getCheckImageUrl() {
      return ossUrl => {
        if (!ossUrl) return "";
        return `${this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL
        )}/apis/sra/reg/users/signup/downloadByFileUrl?fileUrl=${ossUrl}&fileName=`;
      };
    },
    getIsOverseaMobileTranslate() {
      return val => {
        if (val === 0) {
          return "中国";
        } else if (val === 1) {
          return "海外";
        } else {
          return "-";
        }
      };
    },
  },
  created() {
    console.log(this.supplierAccountInfoBO1);
    // this.checkSupplierMobile()
  },
  activated() {
    qrySupAuditDetail({
      supAuditId: this.$route.query.supAuditId,
      isShowLoading: true
    }).then(res => {
      this.searchRegisterCommon({
        supinfoId: res.data.data.supInfoApplyId,
        tempOrFormalFlag: res.data.data.tempOrFormalFlag,
        supAuditId: this.$route.query.supAuditId
      });
      this.supInfoApplyId = res.data.data.supInfoApplyId;
      this.tempOrFormalFlag = res.data.data.tempOrFormalFlag;
      this.supAuditId = this.$route.query.supAuditId;
    });
    this.supplierBaseInfo1.forEach(item => {
      if (item.label == "单位类别:") {
        item.fieldName = "companyCategoryName";
      }
    });
  },
  deactivated() {
    this.activeName = "tab01";
  },
  methods: {
    // 完善信息
    handlePerfect(source) {
      if (source == 1) {
        this.$router.push({
          path: "/maPerfectInfo/applyUsername",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 3
          }
        });
        return;
      }

      if (
        this.basicInfoData.supMatType === "" &&
        this.basicInfoData.supType === ""
      ) {
        this.$router.push({
          path: "/maPerfectInfo/basicInformation",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 3
          }
        });
      } else if (this.supplierContactData.legalContactMobile === "") {
        this.$router.push({
          path: "/maPerfectInfo/contactInformation",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 4
          }
        });
      } else if (this.productInfoData.length === 0) {
        this.$router.push({
          path: "/maPerfectInfo/productInformation",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 5
          }
        });
      } else if (
        this.financeInfoData.bankId === "" &&
        this.financeInfoData.bankName === ""
      ) {
        this.$router.push({
          path: "/maPerfectInfo/financialInformation",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 6
          }
        });
      } else if (this.cooperationPerformanceData.cooperEnterprise === "") {
        this.$router.push({
          path: "/maPerfectInfo/historyCooperation",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 7
          }
        });
      } else if (this.certificatesData.length === 0) {
        this.$router.push({
          path: "/maPerfectInfo/qualificationDocuments",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 8
          }
        });
      } else if (this.auditStatus + "" === "2") {
        this.$router.push({
          path: "/maPerfectInfo/qualificationDocuments",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 9
          }
        });
      } else {
        this.$router.push({
          path: "/maPerfectInfo/applyUsername",
          query: {
            tempSupinfoId: this.supInfoApplyId,
            tempOrFormalFlag: this.tempOrFormalFlag,
            page: 3
          }
        });
      }
    },
    // 撤回申请
    handleRecall() {
      let _this = this;
      let indexList = [];
      let list = [...this.approvalRecordData];
      this.approvalRecordData.forEach((item, index) => {
        if (item.operResultType == 1) {
          indexList.push(index);
        }
      });
      let maxStr = Math.max(...indexList);
      this.approvalRecordDataNew = list.slice(maxStr + 1);
      console.log(indexList, maxStr, this.approvalRecordDataNew, "indexList");
      const recall = this.approvalRecordDataNew.some(item => {
        if (item.operStateFlag != 0) {
          _this.$confirm(
            "贵公司注册信息已开始由" +
              `${item.operatorUnitName}` +
              "审批，不允许供应商撤回注册申请",
            "提示",
            {
              // 贵公司注册信息已开始由"*******"审批，不允许供应商撤回注册申请
              distinguishCancelAndClose: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "ccui-message-box-custom"
            }
          );
          return true;
        } else {
          return false;
        }
      });
      // const recall =  this.approvalRecordData.some(item => {
      //   if(item.operResultType+'' === '2' || item.operResultType+'' === '3') {
      //     this.$confirm("贵公司注册信息已开始由"+`${item.operatorUnitName}`+"审批，不允许供应商撤回注册申请", "提示", {     // 贵公司注册信息已开始由"*******"审批，不允许供应商撤回注册申请
      //       distinguishCancelAndClose: true,
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       customClass: "ccui-message-box-custom",
      //     })
      //     return true
      //   } else {
      //     return false
      //   }
      // else {
      //   this.$confirm("贵公司注册信息还未开始审批，确定要撤回注册申请吗？", "提示", {     // 贵公司注册信息还未开始审批，确定要撤回注册申请吗？
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     customClass: "ccui-message-box-custom",
      //   }).then(() => {
      //     dealSupApprReturn({
      //       operSource: 'sup',
      //       supinfoId: this.supInfoApplyId,
      //       supAuditId: this.supAuditId,
      //       auditType: '1'
      //     }).then(res => {
      //       if(res.data.code === '0' ) {
      //         this.$confirm("撤回申请成功", "提示", {     // 撤回申请成功
      //           distinguishCancelAndClose: true,
      //           confirmButtonText: "确定",
      //           cancelButtonText: "取消",
      //           customClass: "ccui-message-box-custom",
      //         })
      //         // this.searchRegisterCommon({
      //         //   supinfoId: this.$route.query.supInfoApplyId,
      //         //   tempOrFormalFlag: this.$route.query.tempOrFormalFlag
      //         // })
      //         this.checkSupplierMobile()
      //       } else if (res.data.code === 'RP_SP0045') {
      //         this.$confirm(`${res.data.message}`, "提示", {
      //           distinguishCancelAndClose: true,
      //           confirmButtonText: "确定",
      //           cancelButtonText: "取消",
      //           customClass: "ccui-message-box-custom",
      //         })
      //       }
      //     })
      //   }).catch(() => {
      //     this.$message.success('已取消撤回申请')     // 已取消撤回申请
      //   })
      // }
      // })
      console.log(recall, "recall");
      if (!recall) {
        this.$confirm(
          "贵公司注册信息还未开始审批，确定要撤回注册申请吗？",
          "提示",
          {
            // 贵公司注册信息还未开始审批，确定要撤回注册申请吗？
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "ccui-message-box-custom"
          }
        )
          .then(() => {
            dealSupApprReturn({
              operSource: "sup",
              supinfoId: this.supInfoApplyId,
              supAuditId: this.supAuditId,
              auditType: "1"
            }).then(res => {
              if (res.data.code === "0") {
                this.$confirm("撤回申请成功", "提示", {
                  // 撤回申请成功
                  distinguishCancelAndClose: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  customClass: "ccui-message-box-custom"
                });
                // this.searchRegisterCommon({
                //   supinfoId: this.$route.query.supInfoApplyId,
                //   tempOrFormalFlag: this.$route.query.tempOrFormalFlag
                // })
                window.history.go(0);
                // this.checkSupplierMobile()
              } else if (res.data.code === "RP_SP0045") {
                this.$confirm(`${res.data.message}`, "提示", {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  customClass: "ccui-message-box-custom"
                });
              }
            });
          })
          .catch(() => {
            this.$message.success("已取消撤回申请"); // 已取消撤回申请
          });
      }
    },
    // 我已注册
    goser() {
      this.$router.push({
        path: "/regView/mobileValidate"
      });
    },
    //跳转页面公用方法
    jumpPage(url, data) {
      this.$router.push({
        path: url,
        query: data
      });
    },
    handlerPreview(ossUrl) {
      this.imageUrl = "";
      this.imageUrl = this.getCheckImageUrl(ossUrl);
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/config/styles/template-body";
.ldg {
  float: right;
  margin-top: 30px;
  cursor: pointer;
}

.dpng {
  font-size: 16px;
  color: #ffffff;
  line-height: 18px;
  float: left;
  margin-right: 10px;
}

.los img {
  width: 100%;
}

.los {
  width: 18px;
  height: 18px;
  float: left;
}
html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
}

ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

input,
div {
  //border: 0 none;
  border-radius: 0px;
  outline: none;
}

/deep/ .el-bottom-guide .el-bottom-guide-container {
  padding: 0px 170px;
}
/deep/ .el-group-title .group-title {
  color: black;
  border-bottom: 0px;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
</style>
